import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { QuestionnaireService } from "app/services/questionnaire.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HelperService } from "app/services/helper.service";
import { ActivatedRoute } from "@angular/router";
import { TosterMessageService } from "app/services/toster-message.service";
import { QuestionBankService } from "../../services/question-bank.service";

import { UploadService } from "app/services/upload.service";

@Component({
  selector: "app-question-bank-edit-mcq-modal.component",
  templateUrl: "./question-bank-edit-mcq-modal.component.html",
  styleUrls: ["./question-bank-edit-mcq-modal.component.scss"],
  providers: [QuestionBankService],
})
export class QuestionBankEditMcqModalComponent implements OnInit {
  public masterData: any = {};
  validateForm: FormGroup;

  isLoading = false;

  id: number;
  header_id_2: number;
  message = "";
  header_id = 1;
  header_detail_id = 1;

  formData: {
    correct_answer: "";
    correct_all_answer: "";
    answer: "";
    marks: "";
    media_type: "";
    media_link: "";
    header_id: "";
    header_detail_id: "";
  }[] = [];

  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;
  @ViewChild("f") form: any;
  @Output() tableReload: EventEmitter<any> = new EventEmitter();
  @Input() auto_id: number;

  selectedFile: any = {};

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = this.helperService.getSelectedCompanyId();

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private questionBankService: QuestionBankService,
    private UploadService: UploadService
  ) {}

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  ngOnInit() {
    this.validateForm = this.formBuilder.group({
      correct_answer: [{ value: "" }, [Validators.required]],
      correct_all_answer: [{ value: "" }, [Validators.required]],
      answer: [{ value: "" }, [Validators.required]],
      marks: [{ value: "" }, [Validators.required]],
      media_type: [0],
      media_link: [0],
    });

    this.auto_id = Number(localStorage.getItem("question-bank-edit-auto-id"));
    this.header_id_2 = Number(
      localStorage.getItem("question-bank-edit-header-id")
    );
    localStorage.removeItem("question-bank-edit-auto-id");
    localStorage.removeItem("question-bank-edit-header-id");
    this.getQuestionAnsMcq(this.header_id_2);

    localStorage.removeItem("file");
    setInterval(()=> { 
      if(localStorage.getItem("file")){
        this.isLoading = false;
      }
    }, 1500);
  }

  getQuestionAnsMcq(header_id_2: number) {
    this.questionBankService
      .getQuestionAnsMcq(this.header_id_2)
      .get()
      .subscribe((resp) => {
        const data = resp.data.data;
        this.validateForm.get("correct_answer").setValue(data.correct_answer);
        this.validateForm.get("correct_all_answer").setValue(data.correct_all_answer);
        this.validateForm.get("answer").setValue(data.answer);
        this.validateForm.get("marks").setValue(data.marks);
        this.validateForm.get("media_type").setValue(data.media_type);
        this.validateForm.get("media_link").setValue(data.media_link);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isLoading = false;
  }

  async onFileSelected(event: any) { 
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
    const response = await this.UploadService.uploadFile(this.selectedFile);
  }



  updateMcqAns() {
    const requestData = {
      correct_answer: this.validateForm.get("correct_answer").value,
      correct_all_answer: this.validateForm.get("correct_all_answer").value,
      answer: this.validateForm.get("answer").value,
      marks: this.validateForm.get("marks").value,
      media_type: this.validateForm.get("media_type").value,
      media_link: localStorage.getItem("file"),
      header_id: this.header_id_2,
    };
    console.log(requestData);
    localStorage.removeItem("file");

    let that = this;
    this.questionBankService
      .updateQuestionAnsMcq(this.header_id_2)
      .customPUT(requestData)
      .subscribe(
        (resp: any) => {
          this.successMsg = "Successfully updated question answer";
          this.spinner.show();
          this.tableReload.emit();
          this.showSuccessHtml();
          this.closeModalAfterCreate();
          this.tableReload.emit();
          this.spinner.hide();
        },
        (error) => {
          that.htmlErrorMessage = "The entered marks do not match the maximum allowed marks";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(
              error.data.message
            );
            that.showErrorHtml();
          }
          this.tableReload.emit();
        }
      );
    this.tableReload.emit();
    
  }
}



// WEBPACK FOOTER //
// /app/src/app/competancy/question-bank-edit-mcq-modal/question-bank-edit-mcq-modal.component.ts